module.exports = __webpack_public_path__ + "static/media/EMBL_EBI_logo_180pixels_RGB.9db652cf.jpg";